import {Dispatch} from 'redux';

import Types from '../Types';

import AppState from '../../reducers/AppState';

import indexGenerics, {Params as BaseParams} from '../generics/index';

import Mark from '../../../domain/entities/Mark';
import PaginatedResult from '../../../domain/results/PaginatedResult';

import NetMarksRepository from '../../../data/repositories/NetMarksRepository';

const types = {
  failure: Types.IndexMarksFailure,
  request: Types.IndexMarksRequest,
  success: Types.IndexMarksSuccess,
};

export interface Params extends BaseParams {}

export default function action(
  params: Params,
): (
  dispatch: Dispatch<any>,
  getState: () => AppState,
) => Promise<PaginatedResult<Mark>> {
  return indexGenerics(new NetMarksRepository(), types, params);
}
